import { render, staticRenderFns } from "./item-table.vue?vue&type=template&id=b4aeae8e&scoped=true&"
import script from "./item-table.vue?vue&type=script&lang=js&"
export * from "./item-table.vue?vue&type=script&lang=js&"
import style0 from "./item-table.vue?vue&type=style&index=0&id=b4aeae8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aeae8e",
  null
  
)

export default component.exports